import { render, staticRenderFns } from "./closedData.vue?vue&type=template&id=698fd024&scoped=true&"
import script from "./closedData.vue?vue&type=script&lang=js&"
export * from "./closedData.vue?vue&type=script&lang=js&"
import style0 from "./closedData.vue?vue&type=style&index=0&id=698fd024&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698fd024",
  null
  
)

export default component.exports